import MediaGallery from './MediaGallery';

/** A product model's catalog images (MERCH-81, D95): the shared gallery for product_model. */
export default function ModelImages({ modelId }) {
  return <MediaGallery ownerType="product_model" ownerId={modelId} />;
}
